/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {PeriodsInfoChartComponent} from './periods-info-chart.component';
import {CommonModule} from '@angular/common';

@NgModule({
    declarations: [PeriodsInfoChartComponent],
    imports: [
        CommonModule
    ],
    exports: [PeriodsInfoChartComponent]
})
export class PeriodsInfoChartModule {
}
